import React from "react";
import {Stack, Text, Image} from "@chakra-ui/core";

import Content from "~/ui/structure/Content";
import Heading from "~/ui/display/Heading";
import {useTranslation} from "~/i18n/hooks";

const AboutHero: React.FC = () => {
  const t = useTranslation();

  return (
    <Content backgroundColor="primary.100" paddingTop={{base: 12, md: 24}} paddingX={6}>
      <Stack alignItems="center" spacing={12}>
        <Stack
          alignItems={{base: "flex-start", md: "center"}}
          spacing={4}
          textAlign={{base: "left", md: "center"}}
        >
          <Text color="primary.400" fontSize="lg" fontWeight={500} textTransform="uppercase">
            {t("aboutUs.hero.preTitle")}
          </Text>
          <Heading as="h2" fontSize={{base: "2xl", md: "3xl"}} maxWidth={720}>
            {t("aboutUs.hero.title")}
          </Heading>
        </Stack>
        <Image height="100%" maxWidth={900} src="/assets/about-hero.svg" width="100%" />
      </Stack>
    </Content>
  );
};

export default AboutHero;
